(function(){
  if(!window.AUTEL_COMPARE_DATA){
    console.error('Autel Compare data not loaded.');
    return;
  }

  const { DATA, KEYS, LABELS, GROUPS } = window.AUTEL_COMPARE_DATA;

  const selected=[];
  let differencesOnly=true;

  const grid=document.getElementById('acModelGrid');
  const count=document.getElementById('acCount');
  const compareOutput=document.getElementById('acCompareOutput');
  const reco=document.getElementById('acReco');
  const diffBtn=document.getElementById('acDiffBtn');
  const allBtn=document.getElementById('acAllBtn');
  const clearBtn=document.getElementById('acClear');

  if(!grid) return;

  const norm=v=>String(v??'').trim();
  const low=v=>norm(v).toLowerCase();

  function isYes(v){
    const s=low(v);

    return [
      '√',
      'yes',
      'support',
      'supported',
      'true',
      'y'
    ].includes(s) || s.startsWith('support');
  }

  function isNo(v){
    const s=low(v);

    return !s || [
      'x',
      '×',
      'not support',
      'not supported',
      'no',
      'false',
      '/',
      '-',
      'n/a',
      'na'
    ].includes(s);
  }

  function display(v,key){
    const s=norm(v);

    if(key==='Price' && s){
      const n=Number(s);

      if(Number.isFinite(n)){
        return '$'+n.toLocaleString('en-US');
      }

      return esc(s);
    }

    if(isYes(s)){
      return '<span class="ac-yes">✓</span>';
    }

    if(isNo(s)){
      return '<span class="ac-no">—</span>';
    }

    return esc(s);
  }

  function esc(s){
    return String(s).replace(
      /[&<>"']/g,
      c=>({
        '&':'&amp;',
        '<':'&lt;',
        '>':'&gt;',
        '"':'&quot;',
        "'":'&#039;'
      }[c])
    );
  }

  function same(vals){
    return vals.every(
      v=>low(v)===low(vals[0])
    );
  }

  function price(m){
    const n=parseFloat(DATA[m]?.['Price']);

    return Number.isFinite(n)
      ? n
      : null;
  }

  function updateYears(m){
    const s=low(
      DATA[m]?.['Free upgrade years']
    );

    if(/two|2/.test(s)){
      return 2;
    }

    if(/one|1/.test(s)){
      return 1;
    }

    const n=parseFloat(s);

    return Number.isFinite(n)
      ? n
      : null;
  }

  function link(m){
    return DATA[m]?.['Link'] || '#';
  }

  /*
   * ==========================================
   * 统一排序
   * Price：低 → 高
   * ==========================================
   */
  function getSortedSelected(){
    return [...selected].sort((a,b)=>{
      const priceA=price(a);
      const priceB=price(b);

      if(priceA===null && priceB===null){
        return 0;
      }

      if(priceA===null){
        return 1;
      }

      if(priceB===null){
        return -1;
      }

      return priceA-priceB;
    });
  }

  /*
   * ==========================================
   * 型号选择按钮
   * 不再限制最大选择数量
   * ==========================================
   */
  function syncButtons(){
    grid
      .querySelectorAll('.ac-model-btn')
      .forEach(btn=>{

        const m=btn.dataset.model;
        const on=selected.includes(m);

        btn.classList.toggle(
          'is-selected',
          on
        );

        btn.setAttribute(
          'aria-pressed',
          String(on)
        );

        /*
         * 取消数量限制
         */
        btn.disabled=false;
      });

    count.textContent=
      `${selected.length} selected · choose at least 2`;
  }

  grid.addEventListener('click',e=>{
    const btn=e.target.closest(
      '.ac-model-btn'
    );

    if(!btn){
      return;
    }

    const m=btn.dataset.model;
    const idx=selected.indexOf(m);

    if(idx>=0){

      /*
       * 已选择
       * 再次点击取消
       */
      selected.splice(idx,1);

    }else{

      /*
       * 不再限制最多 4 个
       */
      selected.push(m);
    }

    syncButtons();
    render();
  });

  diffBtn.addEventListener(
    'click',
    ()=>{
      differencesOnly=true;

      diffBtn.classList.add('active');
      allBtn.classList.remove('active');

      renderCompare();
    }
  );

  allBtn.addEventListener(
    'click',
    ()=>{
      differencesOnly=false;

      allBtn.classList.add('active');
      diffBtn.classList.remove('active');

      renderCompare();
    }
  );

  clearBtn.addEventListener(
    'click',
    ()=>{
      selected.splice(0);

      syncButtons();
      render();
    }
  );

  function render(){
    renderCompare();
    renderReco();
  }

  /*
   * ==========================================
   * 参数对比表
   * 现在按 Price 低 → 高排列
   * ==========================================
   */
  function renderCompare(){

    if(selected.length<2){

      compareOutput.innerHTML=
        '<div class="ac-empty">Select at least 2 Autel scanners above to compare specifications.</div>';

      return;
    }

    /*
     * 关键：
     * 不再直接使用 selected
     */
    const sortedSelected=
      getSortedSelected();

    let keys=KEYS.filter(
      k=>k!=='Link'
    );

    if(differencesOnly){

      keys=keys.filter(
        k=>!same(
          sortedSelected.map(
            m=>DATA[m][k]
          )
        )
      );
    }

    let html=
      '<div class="ac-table-scroll">'+
      '<table class="ac-table">'+
      '<thead>'+
      '<tr>'+
      '<th>Specification</th>';

    /*
     * 产品标题按照价格排序
     */
    sortedSelected.forEach(m=>{

      html+=`
        <th>
          ${esc(m)}
          <br>
          <a
            class="ac-product-link"
            href="${esc(link(m))}"
            target="_blank"
            rel="noopener"
          >
            View Product
          </a>
        </th>
      `;
    });

    html+=
      '</tr>'+
      '</thead>'+
      '<tbody>';

    let lastGroup='';

    keys.forEach(k=>{

      const g=
        GROUPS[k] || 'Functions';

      if(g!==lastGroup){

        html+=`
          <tr class="ac-group-row">
            <td colspan="${sortedSelected.length+1}">
              ${esc(g)}
            </td>
          </tr>
        `;

        lastGroup=g;
      }

      html+=`
        <tr>
          <td>
            ${esc(LABELS[k]||k)}
          </td>
      `;

      /*
       * 每一行的数据
       * 同样按照价格排序后的产品顺序
       */
      sortedSelected.forEach(m=>{

        const cls=
          k==='Price'
            ? ' class="ac-price"'
            : '';

        html+=`
          <td${cls}>
            ${display(DATA[m][k],k)}
          </td>
        `;
      });

      html+='</tr>';
    });

    if(!keys.length){

      html+=`
        <tr>
          <td
            colspan="${sortedSelected.length+1}"
            style="
              text-align:center;
              padding:28px;
              color:#667085
            "
          >
            No specification differences found in the current data.
          </td>
        </tr>
      `;
    }

    html+=
      '</tbody>'+
      '</table>'+
      '</div>';

    compareOutput.innerHTML=html;
  }

  const IMPORTANT=
    KEYS.filter(k=>[
      'online programming',
      'online coding',
      'active test',
      'd-pdu',
      'rp1210',
      'doip',
      'can fd',
      'diagnostic system topology',
      'remote experts',
      'tpms comprehensive',
      'ev product',
      'battery detection',
      'pre&post scan',
      'scan vin',
      'scan license',
      'renault gateway',
      'fca auto auth',
      'fca sgw'
    ].some(
      term=>low(k).includes(term)
    ));

  const HARDWARE=[
    'RAM',
    'ROM',
    'battery capacity',
    'Android version',
    'Screen size',
    'Screen resolution',
    'Wi-Fi',
    'camera',
    'HDMI',
    'Weight(kg)',
    'VCI'
  ];

  function supportDiffSentence(
    k,
    modelList
  ){

    const yes=modelList.filter(
      m=>isYes(DATA[m][k])
    );

    const no=modelList.filter(
      m=>isNo(DATA[m][k])
    );

    if(
      !yes.length ||
      !no.length
    ){
      return '';
    }

    return `
      <strong>
        ${esc(LABELS[k]||k)}:
      </strong>

      ${esc(yes.join(', '))}
      ${yes.length===1
        ? 'supports'
        : 'support'
      }
      this feature,

      while

      ${esc(no.join(', '))}
      ${no.length===1
        ? 'does'
        : 'do'
      }
      not.
    `;
  }

  /*
   * ==========================================
   * Recommendation
   * 同样按照 Price 低 → 高排列
   * ==========================================
   */
  function renderReco(){

    if(selected.length<2){

      reco.innerHTML=
        '<div class="ac-empty">Select at least 2 models above. The recommendation will update automatically.</div>';

      return;
    }

    const sortedSelected=
      getSortedSelected();

    const funcDiffs=
      IMPORTANT.filter(
        k=>
          KEYS.includes(k) &&
          !same(
            sortedSelected.map(
              m=>DATA[m][k]
            )
          )
      );

    const hardwareDiffs=
      HARDWARE.filter(
        k=>
          KEYS.includes(k) &&
          !same(
            sortedSelected.map(
              m=>DATA[m][k]
            )
          )
      );

    const updates=
      sortedSelected.map(
        m=>({
          m,
          y:updateYears(m),
          raw:
            DATA[m]['Free upgrade years']
        })
      );

    const twoYear=
      updates.filter(
        x=>x.y>=2
      );

    const prices=
      sortedSelected
        .map(
          m=>({
            m,
            p:price(m)
          })
        )
        .filter(
          x=>x.p!==null
        );

    let intro='';

    if(funcDiffs.length===0){

      intro=`
        <p>
          <strong>
            Core functions are very similar across your selected models.
          </strong>
          Based on the current comparison data,
          there are no major differences in the key diagnostic
          functions or protocols checked here.
          Vehicle coverage and day-to-day diagnostic capability
          should therefore be broadly similar;
          your choice mainly comes down to hardware experience,
          software update period and price.
        </p>
      `;

      if(hardwareDiffs.length){

        intro+=`
          <p>
            The main hardware differences are:
            <strong>
              ${
                hardwareDiffs
                  .slice(0,6)
                  .map(
                    k=>esc(
                      LABELS[k]||k
                    )
                  )
                  .join(', ')
              }
            </strong>.
          </p>
        `;
      }

    }else{

      intro=`
        <p>
          <strong>
            There are meaningful function or protocol
            differences between these models.
          </strong>
          Check the items below first.
          If you need one of these capabilities,
          choose a model that explicitly supports it;
          otherwise, compare hardware,
          update period and price.
        </p>
      `;
    }

    if(twoYear.length){

      intro+=`
        <p>
          <strong>
            Software update value:
          </strong>

          ${esc(
            twoYear
              .map(x=>x.m)
              .join(', ')
          )}

          ${
            twoYear.length===1
              ? 'includes'
              : 'include'
          }

          2 years of free software updates,
          which can offer better long-term value
          than a comparable 1-year model.
        </p>
      `;
    }

    if(prices.length>1){

      const lo=prices[0];
      const hi=
        prices[
          prices.length-1
        ];

      const gap=
        hi.p-lo.p;

      intro+=`
        <p>
          <strong>
            Price:
          </strong>

          ${esc(lo.m)}
          is the lowest-priced option at

          <strong>
            ${
              '$'+
              lo.p.toLocaleString(
                'en-US'
              )
            }
          </strong>

          ${
            gap>0
              ? `, $${gap.toLocaleString('en-US')} less than ${esc(hi.m)}`
              : ''
          }.
        </p>
      `;
    }

    let diffs='';

    funcDiffs
      .slice(0,8)
      .forEach(k=>{

        const s=
          supportDiffSentence(
            k,
            sortedSelected
          );

        if(s){

          diffs+=`
            <div class="ac-diff">
              ${s}
            </div>
          `;
        }
      });

    let cards='';

    /*
     * 产品卡片
     * 左 → 右
     * Price 低 → 高
     */
    sortedSelected.forEach(m=>{

      const bullets=[];

      const uy=
        updateYears(m);

      if(uy){

        bullets.push(
          `${uy} year${uy>1?'s':''} free software updates`
        );
      }

      const proto=
        DATA[m]['Bus protocol DoIP/CAN FD'];

      if(
        proto &&
        !isNo(proto)
      ){

        bullets.push(
          `DoIP / CAN FD: ${
            isYes(proto)
              ? 'Supported'
              : proto
          }`
        );
      }

      const dp=
        DATA[m]['Diagnostic standard D-PDU/RP1210'];

      if(
        dp &&
        !isNo(dp)
      ){

        bullets.push(
          `D-PDU / RP1210: ${
            isYes(dp)
              ? 'Supported'
              : dp
          }`
        );
      }

      if(DATA[m]['VCI']){

        bullets.push(
          `VCI: ${
            DATA[m]['VCI']
          }`
        );
      }

      const hw=[
        DATA[m]['RAM'] &&
          `${DATA[m]['RAM']} RAM`,

        DATA[m]['ROM'] &&
          `${DATA[m]['ROM']} storage`,

        DATA[m]['Screen size'] &&
          `${DATA[m]['Screen size']} screen`
      ]
        .filter(Boolean)
        .join(' · ');

      if(hw){
        bullets.push(hw);
      }

      const unique=
        funcDiffs
          .filter(
            k=>
              isYes(DATA[m][k]) &&
              sortedSelected.some(
                o=>
                  o!==m &&
                  isNo(DATA[o][k])
              )
          )
          .slice(0,2);

      unique.forEach(k=>{

        bullets.push(
          `Supports ${
            LABELS[k]||k
          }`
        );
      });

      cards+=`
        <article class="ac-card">

          <h3>
            ${esc(m)}
          </h3>

          <div class="ac-card-price">
            ${
              price(m)!==null
                ? '$'+
                  price(m)
                    .toLocaleString(
                      'en-US'
                    )
                : 'Price unavailable'
            }
          </div>

          <ul>
            ${
              bullets
                .slice(0,6)
                .map(
                  b=>
                    `<li>${esc(b)}</li>`
                )
                .join('')
            }
          </ul>

          <a
            class="ac-view"
            href="${esc(link(m))}"
            target="_blank"
            rel="noopener"
          >
            View ${esc(m)}
          </a>

        </article>
      `;
    });

    reco.innerHTML=`
      <div class="ac-reco-summary">

        <h3>
          Recommendation Based on Your Selection
        </h3>

        ${intro}

        ${
          diffs
            ? `
              <div class="ac-diff-list">
                ${diffs}
              </div>
            `
            : ''
        }

      </div>

      <div class="ac-card-grid">
        ${cards}
      </div>

      <div class="ac-note">
        Vehicle-specific function availability can vary
        by make, model, year and configuration.
        Confirm compatibility for a specific vehicle
        before purchase when needed.
      </div>
    `;
  }

  /*
   * ==========================================
   * Product Page Default Comparison
   * 每个当前产品对应独立的默认对比型号
   * ==========================================
   */
  const PRODUCT_COMPARISON_DEFAULTS = {
    "MX808S": ["MX808S", "MK808BT Pro", "MK900-BT"],
    "MK808Z": ["MK808Z", "MK808BT Pro", "MK900-BT"],
    "MK808BT Pro": ["MX808S", "MK808BT Pro", "MK900-BT"],
    "MX900": ["MX808S", "MX900", "MK900-BT"],
    "MK900-BT": ["MX900", "MK900-BT", "MP900"],
    "MP808S": ["MK808BT Pro", "MP808S", "MP808BT Pro"],
    "MP808BT Pro": ["MP808S", "MP808BT Pro", "MP900-BT"],
    "MP900": ["MP808S", "MP900", "MP900-BT"],
    "MP900-BT": ["MK900-BT", "MP900-BT", "MS906 Pro"],
    "MX808S-TS": ["MX808S", "MX808S-TS", "MX900-TS"],
    "MX900-TS": ["MX900", "MX900-TS", "MP900-TS"],
    "MK900-TS": ["MX900", "MK900-TS", "MP900-TS"],
    "MP900-TS": ["MK900-TS", "MP900-TS", "MS906 Pro-TS"],
    "MS906 Pro": ["MS906 Pro", "MK906S Pro", "MS908S Pro II"],
    "MK906S Pro": ["MS906 Pro", "MK906S Pro", "MS908S Pro II"],
    "MS906 Pro-TS": ["MS906 Pro-TS", "MS908S Pro II", "Elite II Pro"],
    "MK906S Pro2-TS": ["MK906S Pro2-TS", "MS908S Pro II", "Elite II Pro"],
    "MK908 II": ["MK908 II", "MS908S Pro II", "Ultra Lite S"],
    "MS908S Pro II": ["MS908S Pro II", "Elite II Pro", "Ultra Lite S"],
    "Elite II Pro": ["Elite II Pro", "MS909", "Ultra"],
    "Ultra Lite S": ["Ultra Lite S", "MS919", "Ultra"],
    "MS909": ["MS909", "MS919", "Ultra"],
    "MS919": ["MS919", "Ultra", "Ultra S2"],
    "Ultra": ["Ultra", "Ultra S2"],
    "Ultra S2": ["Ultra", "Ultra S2"]
  };

  function normalizeModelName(value){
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(
        /[\s\-–—]+/g,
        ''
      );
  }

  function initProductCompare(){

    const params =
      new URLSearchParams(
        window.location.search
      );

    const urlModel =
      params.get('model');

    const compareRoot =
      document.getElementById(
        'autelScannerCompare'
      );

    const productTitle =
      compareRoot
        ? compareRoot.dataset.currentProductTitle || ''
        : '';

        /* ========================================
   优先根据当前产品 URL 匹配 DATA.Link
======================================== */

function detectModelFromLink(){

  const currentPath =
    window.location.pathname
      .replace(/\/+$/, '')
      .toLowerCase();

  return Object.keys(DATA).find(function(model){

    const productLink =
      DATA[model] && DATA[model].Link;

    if(!productLink){
      return false;
    }

    try{

      const linkPath =
        new URL(
          productLink,
          window.location.origin
        ).pathname
          .replace(/\/+$/, '')
          .toLowerCase();

      return linkPath === currentPath;

    }catch(e){

      return false;

    }

  }) || '';
}
    function detectModelFromTitle(title){

      const normalizedTitle =
        String(title || '').toLowerCase();

      const modelNames =
        Object.keys(
          PRODUCT_COMPARISON_DEFAULTS
        ).sort(
          (a,b) => b.length - a.length
        );

      return modelNames.find(model =>
        normalizedTitle.includes(
          model.toLowerCase()
        )
      ) || '';
    }

const incomingModel =
  urlModel ||
  detectModelFromLink() ||
  detectModelFromTitle(productTitle);

    const notice =
      document.getElementById(
        'acAutoCompareNotice'
      );

    /*
     * 普通 Comparison Page：
     * 没有 ?model= 时，不执行产品页自动推荐。
     */
    if(!incomingModel){

      if(notice){
        notice.style.display='none';
      }

      syncButtons();
      render();

      return;
    }

    const modelButtons =
      Array.from(
        grid.querySelectorAll(
          '.ac-model-btn'
        )
      );

    /*
     * 使用规范化名称匹配当前型号对应的推荐组合。
     */
    const defaultKey =
      Object.keys(
        PRODUCT_COMPARISON_DEFAULTS
      ).find(
        key =>
          normalizeModelName(key) ===
          normalizeModelName(incomingModel)
      );

    /*
     * 如果当前型号暂时没有配置推荐组合：
     * 不自动勾选，保持 Comparison 正常可手动使用。
     */
    if(!defaultKey){

      if(notice){
        notice.style.display='none';
      }

      syncButtons();
      render();

      return;
    }

    const defaultModels =
      PRODUCT_COMPARISON_DEFAULTS[
        defaultKey
      ];

    selected.splice(0);

    /*
     * 按推荐表自动选择。
     * Ultra / Ultra S2 可以只选择 2 个，
     * 其他已配置型号默认选择 3 个。
     */
    defaultModels.forEach(model => {

      const targetButton =
        modelButtons.find(
          btn =>
            normalizeModelName(
              btn.dataset.model
            ) ===
            normalizeModelName(model)
        );

      if(
        targetButton &&
        DATA[targetButton.dataset.model] &&
        !selected.includes(
          targetButton.dataset.model
        )
      ){
        selected.push(
          targetButton.dataset.model
        );
      }
    });

    syncButtons();
    render();

    if(notice){
      notice.style.display='block';
    }

    /*
     * 标记当前正在浏览的产品。
     */
    modelButtons.forEach(btn => {

      const isCurrent =
        normalizeModelName(
          btn.dataset.model
        ) ===
        normalizeModelName(
          incomingModel
        );

      if(isCurrent){

        btn.setAttribute(
          'data-current-product',
          'true'
        );

      }else{

        btn.removeAttribute(
          'data-current-product'
        );
      }
    });
  }

  initProductCompare();

})();